import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from '../../components/runtime-context';
import { EXPERIMENT_EDIT_POST_IN_DASHBOARD } from '@wix/communities-blog-experiments';
import { isExperimentEnabled, createPostInDashboard } from '@wix/communities-blog-client-common';

import { getQueryLocale } from '../../selectors/locale-selectors';
import { getMetaSiteId } from '../../store/instance-values/instance-values-selectors';
import { getIsMobile } from '../../store/basic-params/basic-params-selectors';
import { BUTTON_CREATE_POST } from '../../bi-events/bi-buttons';
import withAuth from '../../hoc/with-auth';

export const CreatePostHandler = ({
  categorySlug,
  children,
  buttonClicked,
  forPublicUser,
  navigateWithinPostPage,
  metaSiteId,
  lang,
  isMobile,
  isEditPostInDashboardEnabled,
}) => {
  const handleClick = () => {
    buttonClicked({ action: BUTTON_CREATE_POST });
    return isEditPostInDashboardEnabled && !isMobile
      ? createPostInDashboard({ metaSiteId, lang })
      : navigateWithinPostPage(`/create-post${categorySlug ? `?categorySlug=${categorySlug}` : ''}`);
  };

  const handleClickDecorated = (...args) => {
    return forPublicUser(handleClick)(...args);
  };

  const child = React.Children.only(children);
  return React.cloneElement(child, { onClick: handleClickDecorated });
};

CreatePostHandler.propTypes = {
  categorySlug: PropTypes.string,
  children: PropTypes.node.isRequired,
  buttonClicked: PropTypes.func,
  forPublicUser: PropTypes.func,
  navigateWithinPostPage: PropTypes.func.isRequired,
  metaSiteId: PropTypes.object,
  lang: PropTypes.string,
  isMobile: PropTypes.bool.isRequired,
  isEditPostInDashboardEnabled: PropTypes.bool,
};

const mapRuntimeToProps = (state, ownProps, actions) => ({
  buttonClicked: actions.buttonClicked,
  navigateWithinPostPage: actions.navigateWithinPostPage,
  metaSiteId: getMetaSiteId(state),
  lang: getQueryLocale(state),
  isMobile: getIsMobile(state),
  isEditPostInDashboardEnabled: isExperimentEnabled(state, EXPERIMENT_EDIT_POST_IN_DASHBOARD),
});

export default flowRight(connect(mapRuntimeToProps), withAuth)(CreatePostHandler);
